import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TempleHinduIcon(props: IconProps) {
    return <Icon {...props} iconKey={"temple_hindu"}/>
}
